export default __webpack_public_path__ + "c2df5a6dd7636e15fce8c478389afcd0.jpg";